import { useTranslations } from 'next-intl'

import { cn } from '@/lib/utils'
import { pushModal } from '@/components/modals'
import { useCurrentUser } from '@/hooks/use-current-user'

export const GetFreeCreditButton = () => {
  return (
    <GetFreeCredit className="whitespace-nowrap font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand/20 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-white/10 hover:bg-white/20 text-white h-10 px-base py-sm rounded-lg" />
  )
}

export const GetFreeCreditButton2 = () => {
  return <GetFreeCredit className="w-full text-sm" />
}

export const GetFreeCreditLink = () => {
  return (
    <GetFreeCredit className="text-[#FDD577]/90 hover:text-[#FDD577] flex items-center gap-2 transition-all duration-300 text-[13px] leading-[1.5] font-normal hover:translate-x-1" />
  )
}

const GetFreeCredit = ({ className }: { className?: string }) => {
  const t = useTranslations('profile-menu')
  const { data: user } = useCurrentUser()

  function handleClick() {
    if (user) {
      pushModal('ReferralModal')
    } else {
      pushModal('LoginModal', { redirectUrl: '/' })
    }
  }

  return (
    <button
      type="button"
      className={cn('flex justify-center items-center gap-2', className)}
      onClick={handleClick}
    >
      <span className="">{t('get_free_credit')}</span>
    </button>
  )
}
